export const HELP_DOCUMENT_API = "v1/help-documents";
